export default __webpack_public_path__ + "static/media/itsmePhone.004e8806.png";